// What a person may do, permanently, and the one dictionary we name to the client. A feature still
// being shipped is withheld by a Rollout instead, so a permission never doubles as one.
// Defined on the backend in App\Security\Access\Permissions.
export enum Permission {
  ManageStock = 'permission.stock.manage',
  SupervisorViewAll = 'permission.access.supervisorViewAll',
  ViewOwnNetbox = 'permission.netbox.viewOwn',
  ViewSensitiveMetrics = 'permission.metrics.viewSensitive',
  ViewStock = 'permission.stock.view',
}
